import axios from "axios";
import { API_BASE_URL } from "../constant";

export const fetchCategories = async () => {
    const userToken = localStorage.getItem("user_token");
    try {
        const config = {
        method: 'get',
        url: `${API_BASE_URL}/get_report_category_list`,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': userToken, 
        },
        withCredentials: true,
        };
    
        const response = await axios(config);
    
        return response.data;
    } catch (error) {
        console.error("Error fetching categories:", error);
        throw error; // optionally re-throw to handle it in calling code
    }
}